<template>
  <d-col xl="4" sm="12" cols="12">
    <h5>Equipamentos</h5>
    <table class="table table-striped table-bordered" role="table">
      <thead class="bg-light" role="rowgroup">
        <tr role="row">
          <th role="columnheader" class="text-center">ID</th>
          <th role="columnheader">Equipamento</th>
          <th role="columnheader">Qtd.</th>
          <th role="columnheader" class="text-right"></th>
        </tr>
      </thead>
      <tbody role="rowgroup">
        <tr
          v-for="(item, navItemId) in model.equipments"
          :key="item.id"
        >
          <td class="p-2 td-1">
            <span class="text-center d-block">{{ item.id }}</span>
          </td>
          <td class="p-2 td-3">
            <span class="d-block" v-if="item.id">{{ item.name }}</span>
            <autocomplete
              v-else
              :ref="`autocompleteEquipment_${navItemId}`"
              placeholder="Equipamento"
              :items="equipments"
              item-show="name"
              :on-input="onInput"
              :on-select="setNewEquipment"
              :on-show-text="showText"
            ></autocomplete>
          </td>
          <td class="p-2 td-1">
            <d-input type="number" class="text-center" v-model="item.quantity" v-if="item.id" />
            <span class="d-block" v-else>{{ item.quantity }}</span>
          </td>
          <td class="p-2 text-center td-1">
            <div class="buttons">
              <i class="fas fa-plus text-success" @click="addRow()" v-if="navItemId + 1 === model.equipments.length"></i>
              <i class="fas fa-minus text-danger" @click="removeRow(navItemId)" ></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </d-col>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Autocomplete from '_shared/Autocomplete.vue';
import { MODEL_QUOTATION_EQUIPMENT, _UPDATE_QUOTATION_PRODUCT_ } from './QuotationModel';

export default {
  name: 'quotation-equipments',
  components: {
    Autocomplete,
  },
  props: {
    model: {
      type: Object,
      default: () => [],
    },
  },
  computed: {
    equipments() {
      const { equipments } = this.$store.state.product;
      if (equipments && equipments.length) {
        return equipments;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'getEquipments',
    ]),
    addRow() {
      this.model.equipments.push({ ...MODEL_QUOTATION_EQUIPMENT });
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getEquipments(name);
      }, 500);
    },
    getEquipmentIndex(equipment) {
      let index = Object.values(this.model.equipments).findIndex(equi => equi.id === equipment.id || equi.id == null);
      if (index === -1) {
        index = this.model.equipments.length;
      }
      return index;
    },
    refreshEquipments() {
      const equipments = [];
      this.model.rows.forEach(row => {
        if (row.product.equipments.length) {
          row.product.equipments.forEach(equipment => {
            const qty = (equipments[equipment.id]) ? Number(equipments[equipment.id].quantity, 10) : 0;
            equipments[equipment.id] = equipment;
            equipments[equipment.id].quantity = qty + Number(row.quantity, 10);
          });
        }
      });
      this.model.equipments = Object.values(equipments);
    },
    removeRow(index) {
      this.model.equipments.splice(index, 1);
      if (this.model.equipments.length === 0) {
        this.addRow();
      }
    },
    setEquipmentInArray(equipment, quantity) {
      const index = this.getEquipmentIndex(equipment);
      const quant = (quantity) ? Number(quantity, 10) : 1;

      equipment.quantity = quant;
      this.$set(this.model.equipments, index, equipment);
    },
    setNewEquipment(equipment) {
      const index = this.getEquipmentIndex(equipment);
      const quant = (this.model.equipments[index]) ? Number(this.model.equipments[index].quantity, 10) : 0;
      const last = this.model.equipments.length - 1;
      if (this.model.equipments[last].id == null) {
        this.removeRow(last);
      }
      this.setEquipmentInArray(equipment, quant + 1);
    },
    showText(item) {
      return `<strong>${item.id}</strong> ${item.name} `;
    },
  },
  mounted() {
    Events.$on(_UPDATE_QUOTATION_PRODUCT_, () => {
      setTimeout(() => {
        this.refreshEquipments();
      }, 50);
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.td {
  &-1 {
    width: 1%;
    max-width: 50px;
    vertical-align: middle;
    .form-control {
      height: 30px;
    }
  }
  &-2 {
    width: 6%;
    vertical-align: middle;
  }
  &-3 {
    width: 10%;
    vertical-align: middle;
  }
}
.buttons {
  text-align: center;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px;
  height: 100%;
  .fa-minus {
    margin-left: 10px;
  }
  i {
    cursor: pointer;
  }
}
</style>
